const angular = require('angular');

const { cartComponentDefinition } = require('./cart.component');
const { cartOffscreenComponentDefinition } = require('./cart-offscreen.component');
const { cartItemComponentDefinition } = require('./cart-item.component');
const { cartItemMessageComponentDefinition } = require('./cart-item-message.component');
const { CartItemMessageService } = require('./cart-item-message.service');
const { cartItemGroupComponentDefinition } = require('./cart-item-group.component');
const { cartControlsComponentDefinition } = require('./cart-controls.component');
const { cartMessageComponentDefinition } = require('./cart-message.component');
const { cartSaveListComponentDefinition } = require('./cart-save-list.component');
const { cartFilterComponentDefinition } = require('./cart-filter.component');
const { cartLoyaltyComponentDefinition } = require('./cart-loyalty.component');
const { cartDeliveryFeeComponentDefinition } = require('./cart-delivery-fee.component');
const { cartDeliveryFeeNotificationComponentDefinition } = require('./cart-delivery-fee-notification.component');
const { cartOrderManagementComponentDefinition } = require('./cart-order-management.component');
const { cartFreeDeliveryRewardsPlusComponentDefinition } = require('./cart-free-delivery-rewards-plus.component');
const { cartBonusPointsRewardsPlusComponentDefinition } = require('./cart-bonus-points-rewards-plus.component');
const { cartCheckoutComponentDefinition } = require('../../../src/shop/cart/cart-checkout.component');
const productDetailConstants = require('../../productdetail/product-detail.constants');

const wowApp = angular.module('wowApp.shop');

wowApp.component('wowCart', cartComponentDefinition);
wowApp.component('wowCartOffscreen', cartOffscreenComponentDefinition);
wowApp.component('wowCartItem', cartItemComponentDefinition);
wowApp.component('wowCartItemMessage', cartItemMessageComponentDefinition);
wowApp.service('CartItemMessageService', CartItemMessageService);
wowApp.component('wowCartItemGroup', cartItemGroupComponentDefinition);
wowApp.component('wowCartControls', cartControlsComponentDefinition);
wowApp.component('wowCartMessage', cartMessageComponentDefinition);
wowApp.component('wowCartSaveList', cartSaveListComponentDefinition);
wowApp.component('wowCartFilter', cartFilterComponentDefinition);
wowApp.component('wowCartLoyalty', cartLoyaltyComponentDefinition);
wowApp.component('wowCartDeliveryFee', cartDeliveryFeeComponentDefinition);
wowApp.component('wowCartDeliveryFeeNotification', cartDeliveryFeeNotificationComponentDefinition);
wowApp.component('wowCartOrderManagement', cartOrderManagementComponentDefinition);
wowApp.component('wowCartFreeDeliveryRewardsPlus', cartFreeDeliveryRewardsPlusComponentDefinition);
wowApp.component('wowCartBonusPointsRewardsPlus', cartBonusPointsRewardsPlusComponentDefinition);
wowApp.constant('ProductDetailConstants', productDetailConstants);
wowApp.component('wowCartCheckout', cartCheckoutComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/cart/index.js